export enum UserSystemRole {
    Admin = 'ADMIN',
    Planner = 'PLANNER',
    ProjectManager = 'PM',
    Lead = 'LEAD',
    Commenter = 'COMMENTER'
}
